//@ts-nocheck

import styled from 'styled-components'
import colorScheme from '../../../theme/colorScheme'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'

export const BannerCarousel = styled.div`
  
`

export const BannerCarouselWrapper = styled.div`
  min-height: auto;
  position: relative;
  border-radius: ${({ theme }) => theme.rem(16)};
  overflow: hidden;

  .swiper-slide {
    height: auto;
  }
`

export const BannerCarouselSlide = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].surface.inside};
  height: 100%;

  ${({ theme }) => theme.mediaQuery.xl(`
    flex-direction: row;
  `)}

  > div:first-child {
    flex: auto;
    flex-grow: 0;

    ${({ theme }) => theme.mediaQuery.xl(`
      flex: 1 1 50%;
    `)}
  }

  > div:last-child {
    flex: auto;
    flex-grow: 1;

    ${({ theme }) => theme.mediaQuery.xl(`
      flex: 1 1 50%;
    `)}
  }
`

export const BannerCarouselSlideImage = styled.div`
  width: 100%;
  position: relative;
  aspect-ratio: 4 / 4;
  overflow: hidden;
  max-height: ${({ theme }) => theme.rem(500)};

  ${({ theme }) => theme.mediaQuery.xl(`
    max-height: initial;
  `)}

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const BannerCarouselSlideText = styled.div`
  width: 100%;
  height: 100%;
  padding: ${({ theme }) => theme.rem(24, 24, 120, 24)};

  ${({ theme }) => theme.mediaQuery.xl(`
    padding: ${theme.rem(92, 60, 60, 60)};
  `)}

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].surface.text.base.primary};
  }
`

export const BannerCarouselSlideTextTagline = styled.p`
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.rem(24)};

  ${({ theme }) => theme.mediaQuery.lg(`
    margin-bottom: ${theme.rem(16)};
  `, true)}
`

export const BannerCarouselSlideTextTitle = styled.p`
  margin-bottom: ${({ theme }) => theme.rem(16)};
`

export const BannerCarouselScrollbarWrapper = styled.div`
  width: calc(100% - 96px);
  position: absolute;
  top: 24px;
  right: 48px;
  z-index: 1;
  display: none;

  ${({ theme }) => theme.mediaQuery.xl(`
    width: calc(50% - 120px);
    right: ${theme.rem(60)};
    top: ${theme.rem(46)};
    display: block;
  `)}
`

export const BannerCarouselScrollbar = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].surface.outside};

  .swiper-scrollbar-drag {
    background: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].button.primary.bgHover};
  }
`

export const BannerCarouselControls = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 32px;
  z-index: 1;

  ${({ theme }) => theme.mediaQuery.xl(`
    bottom: ${theme.rem(60)};
    right: ${theme.rem(60)};
    width: calc(50% - 120px);
    justify-content: right;
  `)}
`

export const BannerCarouselControlsStep = styled.div`
  text-transform: uppercase;
`
export const BannerCarouselControlsNav = styled.div`
  button {
    border-radius: 50%;
    width: ${({ theme }) => theme.rem(46)};
    height: ${({ theme }) => theme.rem(46)};

    &:first-child {
      margin-right: ${({ theme }) => theme.rem(16)};
    }
  }
`
